import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { LeadForm } from './LeadForm';
const TRUST_AVATARS = ['https://randomuser.me/api/portraits/women/44.jpg', 'https://randomuser.me/api/portraits/men/32.jpg', 'https://randomuser.me/api/portraits/women/68.jpg', 'https://randomuser.me/api/portraits/men/75.jpg'];
const BENEFITS = [{
  text: 'Flexible payment plans available',
  highlight: false
}, {
  text: 'Claim Your $3,000 Off now!',
  highlight: true
}];
export function Hero() {
  return <section className="relative bg-brand-dark pt-6 pb-10 lg:pt-20 lg:pb-28 overflow-hidden" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        {/* DESKTOP LAYOUT — two columns */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-8 items-center" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-106">
            <div className="inline-block bg-white/10 text-white border border-white/10 font-medium px-4 py-1.5 rounded-full text-sm mb-6 tracking-wide" data-id="element-107">
              LIMITED TIME INVISALIGN OFFER
            </div>

            <h1 className="text-6xl font-light text-white leading-tight mb-6" data-id="element-108">
              Straighten Your Smile and Save $3,000
            </h1>

            <ul className="space-y-3 mb-8 mt-2" data-id="element-109">
              {BENEFITS.map(benefit => <li key={benefit.text} className={`flex items-center gap-3 text-lg ${benefit.highlight ? 'text-red-500 font-medium' : 'text-white/90'}`} data-id="element-110">
                  <span className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${benefit.highlight ? 'bg-red-500/20' : 'bg-brand-cream/20'}`} data-id="element-111">
                    <CheckIcon className={`w-4 h-4 ${benefit.highlight ? 'text-red-500' : 'text-brand-cream'}`} data-id="element-112" />
                  </span>
                  {benefit.text}
                </li>)}
            </ul>

            <div className="flex items-center gap-4 text-sm text-white/50" data-id="element-113">
              <div className="flex -space-x-2" data-id="element-114">
                {TRUST_AVATARS.map((src, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-brand-dark overflow-hidden" data-id="element-115">
                    <img src={src} alt="Happy patient" className="w-full h-full object-cover" data-id="element-116" />
                  </div>)}
              </div>
              <p data-id="element-117">Join 2,000+ happy patients in Miami Lakes</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative z-10" data-id="element-118">
            <LeadForm data-id="element-119" />
          </motion.div>
        </div>

        {/* MOBILE LAYOUT — single column, centered, text before form */}
        <div className="lg:hidden flex flex-col items-center text-center" data-id="element-120">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="w-full" data-id="element-121">
            <div className="inline-block bg-white/10 text-white border border-white/10 font-medium px-3 py-1 rounded-full text-xs mb-4 tracking-wide" data-id="element-122">
              LIMITED TIME INVISALIGN OFFER
            </div>

            <h1 className="text-3xl md:text-5xl font-light text-white leading-tight mb-4" data-id="element-123">
              Straighten Your Smile and Save $3,000
            </h1>

            <ul className="inline-flex flex-col items-start gap-2 mb-6 mt-1 text-left" data-id="element-124">
              {BENEFITS.map(benefit => <li key={benefit.text} className={`flex items-center gap-2.5 text-sm ${benefit.highlight ? 'text-red-500 font-medium' : 'text-white/90'}`} data-id="element-125">
                  <span className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${benefit.highlight ? 'bg-red-500/20' : 'bg-brand-cream/20'}`} data-id="element-126">
                    <CheckIcon className={`w-3.5 h-3.5 ${benefit.highlight ? 'text-red-500' : 'text-brand-cream'}`} data-id="element-127" />
                  </span>
                  {benefit.text}
                </li>)}
            </ul>
          </motion.div>

          {/* Form after the copy on mobile */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="w-full mb-6" data-id="element-128">
            <LeadForm data-id="element-129" />
          </motion.div>

          {/* Trust indicators below form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex items-center gap-3 text-sm text-white/50" data-id="element-130">
            <div className="flex -space-x-2" data-id="element-131">
              {TRUST_AVATARS.map((src, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-brand-dark overflow-hidden" data-id="element-132">
                  <img src={src} alt="Happy patient" className="w-full h-full object-cover" data-id="element-133" />
                </div>)}
            </div>
            <p data-id="element-134">Join 2,000+ happy patients in Miami Lakes</p>
          </motion.div>
        </div>
      </div>
    </section>;
}